import { useState } from "react";
import { userAPI } from "../features/user/userAPI";

export const useUsers = () => {
  const [user, setUser] = useState(null);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [totalUsers, setTotalUsers] = useState(0);

  const getUser = async (id) => {
    setLoading(true);
    setError(null);

    try {
      const result = await userAPI.getUser(id);

      if (result.success) {
        setUser(result.data.user);
        return result.data.user;
      } else {
        setError(result.error);
        return { success: false, error: result.error };
      }
    } catch (err) {
      const errorMessage = "Đã xảy ra lỗi không mong muốn";
      setError(errorMessage);
      return { success: false, error: errorMessage };
    } finally {
      setLoading(false);
    }
  };

  const updateProfile = async (profileData) => {
    setLoading(true);
    setError(null);

    try {
      const result = await userAPI.updateProfile(profileData);

      if (result.success) {
        setUser(result.data.user);
        return result.data;
      } else {
        setError(result.error);
        return { success: false, error: result.error };
      }
    } catch (err) {
      const errorMessage = "Đã xảy ra lỗi không mong muốn";
      setError(errorMessage);
      return { success: false, error: errorMessage };
    } finally {
      setLoading(false);
    }
  };

  const getUserStats = async () => {
    setLoading(true);
    setError(null);

    try {
      const result = await userAPI.getUserStats();

      if (result.success) {
        // Giả định rằng API trả về totalUsers trong dữ liệu
        setTotalUsers(result.data.totalUsers || 0);
        return {
          totalUsers: result.data.totalUsers || 0,
          success: true,
        };
      } else {
        setError(result.error);
        return { success: false, error: result.error };
      }
    } catch (err) {
      const errorMessage = "Đã xảy ra lỗi không mong muốn";
      setError(errorMessage);
      return { success: false, error: errorMessage };
    } finally {
      setLoading(false);
    }
  };

  const getUserCount = async () => {
    setLoading(true);
    setError(null);

    try {
      const result = await userAPI.getUserCount();

      if (result.success) {
        // API trả về count trong data
        setTotalUsers(result.data.count || 0);
        return {
          totalUsers: result.data.count || 0,
          success: true,
        };
      } else {
        setError(result.error);
        return { success: false, error: result.error };
      }
    } catch (err) {
      const errorMessage = "Đã xảy ra lỗi khi lấy số lượng người dùng";
      setError(errorMessage);
      return { success: false, error: errorMessage };
    } finally {
      setLoading(false);
    }
  };

  const getDashboard = async () => {
    setLoading(true);
    setError(null);

    try {
      const result = await userAPI.getDashboard();

      if (result.success) {
        return result.data;
      } else {
        setError(result.error);
        return { success: false, error: result.error };
      }
    } catch (err) {
      const errorMessage = "Đã xảy ra lỗi không mong muốn";
      setError(errorMessage);
      return { success: false, error: errorMessage };
    } finally {
      setLoading(false);
    }
  };

  return {
    user,
    users,
    totalUsers,
    loading,
    error,
    getUser,
    updateProfile,
    getUserStats,
    getUserCount,
    getDashboard,
  };
};
